/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { mutationOptionsWithInteraction } from '../../mutationOptions'
import { customInstance } from '../../mutator'
import type {
  AttachmentInDTO,
  FileDTO,
  FileUsageDTO,
  HTTPValidationError,
} from '../fastAPI.schemas'

/**
 * Attach a project file ("Dateien") to a markdown page, or detach it.
 * @summary Set Document Attachment
 */
export const setDocumentAttachment = (
  projectGuid: string,
  rootFolderGuid: string,
  fileGuid: string,
  attachmentInDTO: AttachmentInDTO,
) => {
  return customInstance<FileDTO>({
    url: `/projects/${projectGuid}/files/${rootFolderGuid}/file/${fileGuid}/attachment`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: attachmentInDTO,
  })
}

export const useSetDocumentAttachmentMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDocumentAttachment>>,
    TError,
    { projectGuid: string; rootFolderGuid: string; fileGuid: string; data: AttachmentInDTO },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof setDocumentAttachment>>,
  TError,
  { projectGuid: string; rootFolderGuid: string; fileGuid: string; data: AttachmentInDTO },
  TContext
> => {
  const mutationKey = ['setDocumentAttachment']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setDocumentAttachment>>,
    { projectGuid: string; rootFolderGuid: string; fileGuid: string; data: AttachmentInDTO }
  > = props => {
    const { projectGuid, rootFolderGuid, fileGuid, data } = props ?? {}

    return setDocumentAttachment(projectGuid, rootFolderGuid, fileGuid, data)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/files/{rootFolderGuid}/file/{fileGuid}/attachment` },
    {
      operationId:
        'set_document_attachment_projects__project_guid__files__root_folder_guid__file__file_guid__attachment_put',
      operationName: 'setDocumentAttachment',
    },
  )

  return customOptions
}

export type SetDocumentAttachmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof setDocumentAttachment>>
>
export type SetDocumentAttachmentMutationBody = AttachmentInDTO
export type SetDocumentAttachmentMutationError = HTTPValidationError

/**
 * @summary Set Document Attachment
 */
export const useSetDocumentAttachment = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDocumentAttachment>>,
    TError,
    { projectGuid: string; rootFolderGuid: string; fileGuid: string; data: AttachmentInDTO },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof setDocumentAttachment>>,
  TError,
  { projectGuid: string; rootFolderGuid: string; fileGuid: string; data: AttachmentInDTO },
  TContext
> => {
  const mutationOptions = useSetDocumentAttachmentMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Replace the attached project file of a markdown page with a copy of it, so
it can be edited without changing the other items that show the original.
 * @summary Copy Document Attachment
 */
export const copyDocumentAttachment = (
  projectGuid: string,
  rootFolderGuid: string,
  fileGuid: string,
  signal?: AbortSignal,
) => {
  return customInstance<FileDTO>({
    url: `/projects/${projectGuid}/files/${rootFolderGuid}/file/${fileGuid}/attachment/copy`,
    method: 'POST',
    signal,
  })
}

export const useCopyDocumentAttachmentMutationOptions = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyDocumentAttachment>>,
    TError,
    { projectGuid: string; rootFolderGuid: string; fileGuid: string },
    TContext
  >
}): UseMutationOptions<
  Awaited<ReturnType<typeof copyDocumentAttachment>>,
  TError,
  { projectGuid: string; rootFolderGuid: string; fileGuid: string },
  TContext
> => {
  const mutationKey = ['copyDocumentAttachment']
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof copyDocumentAttachment>>,
    { projectGuid: string; rootFolderGuid: string; fileGuid: string }
  > = props => {
    const { projectGuid, rootFolderGuid, fileGuid } = props ?? {}

    return copyDocumentAttachment(projectGuid, rootFolderGuid, fileGuid)
  }

  const customOptions = mutationOptionsWithInteraction(
    { ...mutationOptions, mutationFn },
    { url: `/projects/{projectGuid}/files/{rootFolderGuid}/file/{fileGuid}/attachment/copy` },
    {
      operationId:
        'copy_document_attachment_projects__project_guid__files__root_folder_guid__file__file_guid__attachment_copy_post',
      operationName: 'copyDocumentAttachment',
    },
  )

  return customOptions
}

export type CopyDocumentAttachmentMutationResult = NonNullable<
  Awaited<ReturnType<typeof copyDocumentAttachment>>
>

export type CopyDocumentAttachmentMutationError = HTTPValidationError

/**
 * @summary Copy Document Attachment
 */
export const useCopyDocumentAttachment = <
  TError = HTTPValidationError,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof copyDocumentAttachment>>,
    TError,
    { projectGuid: string; rootFolderGuid: string; fileGuid: string },
    TContext
  >
}): UseMutationResult<
  Awaited<ReturnType<typeof copyDocumentAttachment>>,
  TError,
  { projectGuid: string; rootFolderGuid: string; fileGuid: string },
  TContext
> => {
  const mutationOptions = useCopyDocumentAttachmentMutationOptions(options)

  return useMutation(mutationOptions)
}
/**
 * Document items that show a project file ("Dateien"). The file can only be
deleted once none is left (MD-CORE-0021).
 * @summary Get File Usages
 */
export const getFileUsages = (
  projectGuid: string,
  rootFolderGuid: string,
  fileGuid: string,
  signal?: AbortSignal,
) => {
  return customInstance<FileUsageDTO[]>({
    url: `/projects/${projectGuid}/files/${rootFolderGuid}/file/${fileGuid}/usages`,
    method: 'GET',
    signal,
  })
}

export const getGetFileUsagesQueryKey = (
  projectGuid?: string,
  rootFolderGuid?: string,
  fileGuid?: string,
) => {
  return [`/projects/${projectGuid}/files/${rootFolderGuid}/file/${fileGuid}/usages`] as const
}

export const getGetFileUsagesQueryOptions = <
  TData = Awaited<ReturnType<typeof getFileUsages>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  rootFolderGuid: string,
  fileGuid: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getFileUsages>>, TError, TData> },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey =
    queryOptions?.queryKey ?? getGetFileUsagesQueryKey(projectGuid, rootFolderGuid, fileGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getFileUsages>>> = ({ signal }) =>
    getFileUsages(projectGuid, rootFolderGuid, fileGuid, signal)

  return {
    queryKey,
    queryFn,
    enabled: !!(projectGuid && rootFolderGuid && fileGuid),
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getFileUsages>>, TError, TData> & {
    queryKey: QueryKey
  }
}

export type GetFileUsagesQueryResult = NonNullable<Awaited<ReturnType<typeof getFileUsages>>>
export type GetFileUsagesQueryError = HTTPValidationError

/**
 * @summary Get File Usages
 */

export function useGetFileUsages<
  TData = Awaited<ReturnType<typeof getFileUsages>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  rootFolderGuid: string,
  fileGuid: string,
  options?: { query?: UseQueryOptions<Awaited<ReturnType<typeof getFileUsages>>, TError, TData> },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetFileUsagesQueryOptions(projectGuid, rootFolderGuid, fileGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
